module.exports = __webpack_public_path__ + "img/play.d5c4cb68.svg";